export const dashboardData = ['Dashboard', 'Add User', 'Finances'];
